module.exports = "/cyber/_next/static/images/pubgMobileBanner-cb8c6aa31b475535b06593a06f7bfeb6.jpg";